<script lang="ts">
import { defineComponent } from 'vue';
import { AisPagination } from 'vue-instantsearch/vue3/es';

export default defineComponent({
  components: { AisPagination },
  emits: ['pageChange'],
});
</script>
<template>
  <ais-pagination @page-change="$emit('pageChange')">
    <template
      #default="{ currentRefinement, nbPages, pages, isFirstPage, isLastPage, refine, createURL }"
    >
      <ul
        v-if="nbPages > 1"
        class="mx-auto mt-12 flex w-full max-w-container items-center justify-between gap-x-6 text-[#151517] sm:justify-center md:mt-16"
      >
        <!--If we have any previous pages, add the left arrow -->
        <li v-if="!isFirstPage">
          <a
            :href="createURL(currentRefinement - 1)"
            aria-label="Previous page"
            @click.exact.prevent="refine(currentRefinement - 1)"
          >
            <svg width="48" height="48" class="text-ick-green-700" aria-hidden="true">
              <use xlink:href="#chevron-circle" />
            </svg>
          </a>
        </li>

        <!-- Get the dynamic page range in the middle -->
        <template
          v-for="page in pages.filter((num: number) => Math.abs(num - currentRefinement) <= 1)"
          :key="page"
        >
          <li
            v-if="page === currentRefinement"
            class="font-base grid size-10.5 place-items-center rounded-full bg-ick-lime-500 font-bold"
            :aria-label="`Page number ${page}`"
            aria-current="page"
          >
            <!-- 0-based -->
            {{ page + 1 }}
          </li>
          <li v-else>
            <a
              :href="createURL(page)"
              class="text-base font-bold"
              :aria-label="`Page number ${page}`"
              @click.exact.prevent="refine(page)"
            >
              <!-- 0-based -->
              {{ page + 1 }}
            </a>
          </li>
        </template>

        <!-- If we have any additional pages, add the right arrow -->
        <li v-if="!isLastPage">
          <a
            :href="createURL(currentRefinement + 1)"
            aria-label="Next page"
            @click.exact.prevent="refine(currentRefinement + 1)"
          >
            <svg width="48" height="48" class="rotate-180 text-ick-green-700" aria-hidden="true">
              <use xlink:href="#chevron-circle" />
            </svg>
          </a>
        </li>
      </ul>
      <!-- Empty as we want no output -->
      <div v-else aria-hidden="true"></div>
    </template>
  </ais-pagination>
</template>
